// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EventEmptyCell_button__iZEtT {\n  color: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Event/EventEmptyCell.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC","sourcesContent":[".button {\n  color: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "EventEmptyCell_button__iZEtT"
};
export default ___CSS_LOADER_EXPORT___;
